import { withLayout } from '../../layout';

import { Settings } from './settings.page';

export default withLayout(Settings);
